/* eslint-disable */
import {useContext, useDebugValue} from 'react';
import context from './context';

/**
 *
 * @returns {[
 *   Array<{
 *     id: string;
 *     resolve: (optionId: string|number) => void;
 *     reject: () => void;
 *     content: string;
 *     icon?: JSX.Element;
 *     options: Array<{
 *       id: string|number;
 *       content: string;
 *       secondary?: boolean;
 *     }>;
 *   }>,
 *   {
 *     prompt: (args: {
 *       icon?: JSX.Element,
 *       content: string,
 *       options: Array,
 *     }) => [Promise<string|number>, () => void];
 *     cancelPrompt: () => void;
 *   }
 * ]}
 */
const usePrompts = () => {
  const { prompt, cancelPrompt, prompts } = useContext(context);
  useDebugValue(prompts);
  return [
    prompts,
    {
      prompt,
      cancelPrompt,
    },
  ];
};

export default usePrompts;
